import React from "react";
import { Box, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import RegisterForm from "../components/forms/RegisterForm";

export default function Register() {
    const navigate = useNavigate();
    
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', px: { xs: 2, sm: 3 }, backgroundColor: 'primary.main', minHeight: '100vh', justifyContent: 'center' }}>
            <a href="/"><img src={require('../assets/logo-esdras7.png')} alt="Logo" style={{ width: '90vw', maxWidth: '350px', display: 'block' }} /></a>
            
            <Container maxWidth='sm' sx={{ display:'flex', flexDirection:'column', minWidth: { xs: '280px', sm: '300px' }, width: '100%', backgroundColor: 'rgba(255, 255, 255, 0.8)', padding: { xs: 2, sm: 3 }, borderRadius: 2, mb: 4 }}>
                <RegisterForm {...{onLogin:()=>navigate('/')}} />
            </Container> 
        </Box>
    );
}